var CategoryFilter = (function () {
    function CategoryFilter() {
    }
    CategoryFilter.prototype.transform = function (items, filter) {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(function (item) { return item.categories.find(function (cat) { return cat._id == filter; }) != undefined; });
    };
    return CategoryFilter;
}());
export { CategoryFilter };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/shared/pipes/category-filter/category-filter.pipe.ts.pre-build-optimizer.js